import { memo } from 'react';

import { usePosts } from '../hooks/usePosts';

const LoadMore = () => {
  const { loadPosts } = usePosts();
  return (
    <button type='button' onClick={loadPosts}>
      LOAD MORE
    </button>
  );
};

export default memo(LoadMore);
